import { ConsentListComponent } from './../../../modules/consent-managements/consent-list/consent-list.component';
import { Component, OnInit, Inject } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { IMenu, Menu, MenuSearch } from "usermanagement-boothelp/src/app/shared/models/menu.model";
import { DigitalMailboxService } from '@app/core/services/digital-mailbox.service';
import { AppConstant } from '@app/configs/app.constant';
import { AlertService } from '@app/core/services/alert.service';
import { ceil, floor } from 'lodash';
import { Subject, Subscription } from 'rxjs';
import { FetchDigitalMailboxService } from "@app/core/services/fetch-digital-mailbox.service";
import { TranslateService } from "@ngx-translate/core";
import { APP_CONFIG, AppConfig } from '@app/app-config.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import Swal from "sweetalert2";
import { LogoutAdfsComponent } from '@app/modules/auth/logout-adfs/logout-adfs.component';
import { mdConfig } from 'usermanagement-boothelp/src/app/configs/app-package.config';
import { UserChangePwdComponent } from "@app/modules/user-change-pwds/user-change-pwd/user-change-pwd.component";
import { MenuService } from "usermanagement-boothelp/src/app/core/services/menu.service";
import { BsModalService } from "ngx-bootstrap/modal";
import * as _ from 'lodash';
import { CheckCanUseService } from "@app/core/services/check-can-use.service";
import { modulesConfig } from '@app/configs/module.config';
import {
  IModuleConfig,
  IExternalLinkConfig,
  ModuleType,
  ModuleCode
} from '@app/core/models/project-config.model';
import { CheckCompanyCanUserServiceRequest, ResultCheckCompanyCanUserService, ServiceInfo } from "@app/core/models/manage-service.model";
import { UserManagementService } from "@app/core/services/user-management.service";
import { NgxPermissionsService } from "ngx-permissions";
import { ManageService } from "@app/core/services/manage-service.service";
import { ClientsSessionService } from "@app/shared/services/client-session.service";
declare var beconsent:any;
declare var dsrm:any;

@Component({
  selector: 'app-digital-mailbox-sidebar',
  templateUrl: './digital-mailbox-sidebar.component.html',
  styleUrls: ['./digital-mailbox-sidebar.component.css']
})
export class DigitalMailboxSidebarComponent implements OnInit {
  public isLoading: boolean = false;
  public imenus: IMenu[] = [];
  public externalLinkConfig: IExternalLinkConfig;
  private serviceInfo: ServiceInfo[];
  max: number = 100;
  value: number = 80;
  countInboxUnread: number = 0;
  countDrafts: number = 0;
  usagePercent: number = 0;
  lang: string;
  public profileImage: any = null;
  // public menus: IMenu[];
  public menus: [
    {
      id: string,
      isSubMenu: boolean,
      menuId: number,
      parentMenuId: string,
      name: string,
      order: number,
      url: string,
      icon: string,
      createTime: string,
      lastUpdateTime: string,
      submenu: [
        {
          id: number,
          isSubMenu: boolean,
          parentMenuId: number,
          name: string,
          order: number,
          url: string,
          icon: string,
          createTime: string,
          lastUpdateTime: string,
        },
        {
          id: number,
          isSubMenu: boolean,
          parentMenuId: number,
          name: string,
          order: number,
          url: string,
          icon: string,
          createTime: string,
          lastUpdateTime: string,
        },
        {
          id: number,
          isSubMenu: boolean,
          parentMenuId: number,
          name: string,
          order: number,
          url: string,
          icon: string,
          createTime: string,
          lastUpdateTime: string,
        },
        {
          id: number,
          isSubMenu: boolean,
          parentMenuId: number,
          name: string,
          order: number,
          url: string,
          icon: string,
          createTime: string,
          lastUpdateTime: string,
        },
        {
          id: number,
          isSubMenu: boolean,
          parentMenuId: number,
          name: string,
          order: number,
          url: string,
          icon: string,
          createTime: string,
          lastUpdateTime: string,
        }
      ]
    }
  ];

  public showMenu: string = "";
  public currentUser: any;
  public subscription!: Subscription;
  public subscriptionCheckCanUse!: Subscription;
  public isDesktop: boolean = false;
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private router: Router,
    private digitalMailboxService: DigitalMailboxService,
    private alertService: AlertService,
    private fetchDigitalMailboxService: FetchDigitalMailboxService,
    private checkCanUseService: CheckCanUseService,
    public translate: TranslateService,
    private deviceService: DeviceDetectorService, 
    private modalService: BsModalService,
    private menuService: MenuService,
    private userManagementService: UserManagementService,
    private permissionsService: NgxPermissionsService,    
    private manageService: ManageService,
    private clientService: ClientsSessionService,

  ) {
    if(this.deviceService.getDeviceInfo().deviceType == 'desktop'){
      this.isDesktop = true;
    }
    this.permissionsService.flushPermissions();
    this.clientService.init();
  }

  ngOnInit() {
    this.lang = sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : this.config.defaultLanguage;
    this.translate.use(this.lang);
    this.getCurrentLoggedon();
    this.initialMenu();
    this.permissionsService.loadPermissions(
      this.clientService.getPermissions()
    );
    this.getService();
    if (this.menus) {
      this.addExpandClass(this.menus[0].menuId);
    }
    let mailboxUser = JSON.parse(sessionStorage.getItem("mailboxUser") || '{}');
    this.profileImage = mailboxUser['profilePicture'];
    this.subscription = this.fetchDigitalMailboxService.fetch().subscribe((data: any) => { 
      if(data){
        this.getCountMessage();
      }
    });

    this.subscriptionCheckCanUse = this.checkCanUseService.check().subscribe((data: any) => { 
      if(data){
        this.checkServiceCode(data.serviceCode, data.moduleName, data.external, data.useApiConfigValue, data.urlPath,);
      }
    });
  }

  getService() {
    this.manageService.listService().subscribe({next: (v) => {
      this.serviceInfo = v.data.result;
    }, error:(e)=>{

    }})
  }

  async checkServiceCode(serviceCode: string, moduleName : string, external: boolean, useApiConfigValue: boolean, urlPath: string){
    console.log("serviceCode : ",serviceCode)
    const canUserService = await this.checkIdentity(serviceCode);      
    if(!canUserService.can) {
      if(canUserService.selfService){
        this.alertService.warningKYC(this.translate.instant('KYC.Please KYC on mobile'),this.translate.instant('KYC.Warning KYC'))
      } else { 
        this.alertService.confirm(this.translate.instant('KYC.ServiceRequireAlert', {moduleName : moduleName}),this.translate.instant('KYC.Please KYC'))
        .then((confirm)=> {                    
          if(confirm.value){
            this.router.navigate(["/mainmenu/kyc"], { state: {identity: canUserService.requireIdentityTypeIdList}});
          }
        });
      }
      return ;
    } else {      
      const moduleFilter = modulesConfig.filter((element) => element.code == serviceCode);
      const checkPermission = await this.permissionsService.hasPermission(moduleFilter[0].permissions!);      
      if(!checkPermission){
       this.alertService.error(this.translate.instant('notHavePermission'));
       return this.router.navigate(["/dashboard"]); 
      }
      await this.getListPermission();        
    }
    if(serviceCode == ModuleCode.PrintAndPost){
      console.log("check can use document management for print and post") 
      const canUserService = await this.checkIdentity(ModuleCode.DocumentManagement);      
      if(!canUserService.can) {
        if(canUserService.selfService){
          this.alertService.warningKYC(this.translate.instant('KYC.Please KYC on mobile'),this.translate.instant('KYC.Warning KYC'))
        } else { 
          let moduleFilter = modulesConfig.filter((service) => service.serviceCode == ModuleCode.DocumentManagement); 
          this.alertService.confirm(this.translate.instant('KYC.ServiceRequireAlert', {moduleName : moduleFilter[0].name}),this.translate.instant('KYC.Please KYC'))
          .then((confirm)=> {                    
            if(confirm.value){
              this.router.navigate(["/mainmenu/kyc"], { state: {identity: canUserService.requireIdentityTypeIdList}});
            }
          });
        }  
        return ;
      } else {      
        const moduleFilter = modulesConfig.filter((element) => element.code == serviceCode);
        const checkPermission = await this.permissionsService.hasPermission(moduleFilter[0].permissions!);      
        if(!checkPermission){
         this.alertService.error(this.translate.instant('notHavePermission'));
         return this.router.navigate(["/dashboard"]); 
        }  
        await this.getListPermission();        
      }
    }
    switch (external) {
      case false:
        this.onInternalModule(urlPath);
        break;
      case true:
        if(this.deviceService.getDeviceInfo().browser == 'Safari') return true;
        else this.onExternalModule(urlPath, useApiConfigValue);
        break;
      default:
        throw new Error(this.translate.instant('KYC.Module not implemented.'));
    }
  }

  onInternalModule(routePath: string) {
    const dom: any = document.querySelector("body");    
    if(dom.classList.contains('menuleft-hide')){
      dom.classList.toggle("menuleft-hide");
    }
    this.router.navigate([routePath]);
  }

  onExternalModule(urlPath: string, useApiConfigValue: boolean) { 
    if (useApiConfigValue) {
      urlPath = this.externalLinkConfig[urlPath];  
    }    
      window.open(urlPath, '_blank');       
  }

  checkIdentity(serviceCode: string) : Promise<ResultCheckCompanyCanUserService>{ 
    return new Promise((resolve) => { 
      let serviceFileter = this.serviceInfo.filter((service) => service.serviceCode == serviceCode);
      if(serviceFileter.length == 0) return this.alertService.error(this.translate.instant("KYC.Not found service"));
      const serviceID = serviceFileter[0].serviceId; 
      let checkCompanyCanUserServiceRequest: CheckCompanyCanUserServiceRequest = {cpid: this.clientService.getCpid(), serviceId: serviceID};
      this.manageService.checkCompanyCanUseService(checkCompanyCanUserServiceRequest).subscribe({next:(v)=> {
        if(v.code === AppConstant.HTTP_STATUS_CODE_SUCCESS){
          resolve(v.data);
        }
      }, error:(e)=> {
          resolve(new ResultCheckCompanyCanUserService({can: false,requireIdentityTypeIdList: []}));
      }});
    });   
  }

  getListPermission() : Promise<boolean>{
    return new Promise((resolve) => {            
      this.userManagementService.getListPermission().subscribe({next:(v)=> {
        if(v.code === AppConstant.HTTP_STATUS_CODE_SUCCESS){
          let currentUser = JSON.parse(
            sessionStorage.getItem("currentUser") || "{}"
          );          
          currentUser['permissions'] = v.data
          sessionStorage.setItem("currentUser",JSON.stringify(currentUser));
          resolve(true);
        }
      }, error:(e)=> {
          resolve(true);
      }});
    });      
  }


  changeLanguage(lang) {
    console.log("lang : ", lang)
    this.translate.use(lang);
    sessionStorage.setItem("lang", lang)
    this.lang = lang;
    this.translate.reloadLang(this.lang).subscribe({
      next: (v) => {        
        this.initialMenu();        
      },
      error: (e) => {
        
      }
    });       
  }

  initialMenu() {
    this.menus = [
      {
        id: "1",
        isSubMenu: false,
        menuId: 1,
        parentMenuId: "0",
        name: "DIGITALMAILBOX.Mails",
        order: 1,
        url: null,
        icon: "inbox",
        createTime: "2020-08-03T17:00:00.000Z",
        lastUpdateTime: "2023-06-27T08:34:02.000Z",
        submenu: [
          {
            createTime: "2020-08-03T17:00:00.000Z",
            icon: null,
            id: 4,
            isSubMenu: true,
            lastUpdateTime: "2023-08-10T12:30:05.000Z",
            name: "DIGITALMAILBOX.All Mails",
            order: 1,
            parentMenuId: 1,
            url: "/digitalmailbox/inbox-document/INBOX"
          },
          {
            createTime: "2020-08-03T17:00:00.000Z",
            icon: null,
            id: 5,
            isSubMenu: true,
            lastUpdateTime: "2023-08-10T12:30:05.000Z",
            name: "DIGITALMAILBOX.Starred Mails",
            order: 1,
            parentMenuId: 2,
            url: "/digitalmailbox/inbox-document/Favorite"
          },
          {
            createTime: "2020-08-03T17:00:00.000Z",
            icon: null,
            id: 6,
            isSubMenu: true,
            lastUpdateTime: "2023-08-10T12:30:05.000Z",
            name: "DIGITALMAILBOX.Mail Drafts",
            order: 2,
            parentMenuId: 3,
            url: "/digitalmailbox/inbox-document/Drafts"
          },
          {
            createTime: "2020-08-03T17:00:00.000Z",
            icon: null,
            id: 7,
            isSubMenu: true,
            lastUpdateTime: "2023-08-10T12:30:05.000Z",
            name: "DIGITALMAILBOX.Sent Mails",
            order: 2,
            parentMenuId: 4,
            url: "/digitalmailbox/inbox-document/Sent"
          },
          {
            createTime: "2020-08-03T17:00:00.000Z",
            icon: null,
            id: 8,
            isSubMenu: true,
            lastUpdateTime: "2023-08-10T12:30:05.000Z",
            name: "DIGITALMAILBOX.Trash",
            order: 2,
            parentMenuId: 5,
            url: "/digitalmailbox/inbox-document/Trash"
          }
        ]
      }
    ];
  }
  addExpandClass(element: any) {
    console.log("element : ", element)
    this.showMenu =
      element === this.showMenu
        ? (this.showMenu = "0")
        : (this.showMenu = element);
  }

  menuChange(menu: string, url: string, isInit: boolean = false) {
    console.log("url: ", url)
    if (!isInit) {
      console.log("if")
      this.router
        .navigateByUrl('/reload', { skipLocationChange: true })
        .then(() => {
          this.router.navigate([url]);
          //// mobile & ipad auto close sidebar
          if(!this.isDesktop){
            this.toggleSidebar()
          }
          
        })
    } else {
      console.log("else")
      this.router.navigate([url]);
      //// mobile & ipad auto close sidebar
      if(!this.isDesktop){
        this.toggleSidebar()
      }
    }
  }

  getCurrentLoggedon() {
    this.currentUser = JSON.parse(
      sessionStorage.getItem("currentUser") || "{}"
    );
  }

  getCountMessage() {
    this.digitalMailboxService.getCountMessage()
      .subscribe({
        next: (v) => {
          if (v.code == AppConstant.HTTP_STATUS_CODE_SUCCESS) {
            this.countInboxUnread = v.data[0].countMessage;
            this.countDrafts = v.data[2].countMessage;
            this.value = 0;
            for (let info of v.data) {
              this.value += info.size;
            }
            this.usagePercent = floor(this.value / 500000000 * 100);
          }
        },
        error: (e) => {
          this.alertService.error(e.message)
        }
      })
  }

  toggleSidebar() {
    const dom: any = document.querySelector("body");
    dom.classList.toggle("menuleft-hide");
  }

  deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  logout() {

    Swal.fire({
      text: this.translate.instant("WARNING.Are you sure you want to logout") + " ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      confirmButtonText: this.translate.instant("Yes"),
      cancelButtonText: this.translate.instant("No"),
    }).then((result) => {
      if (result.value) {        
                
        this.deleteAllCookies();    
        
        this.modalService.show(LogoutAdfsComponent, {
          ...mdConfig,
          class: "modal-lg",
        });        
      }
    });
  }

  profile() {
    this.router.navigate(["/mainmenu/profile"]);
  }

  otp() {
    this.router.navigate(["/mainmenu/otp"]);
  }


  changePassword() {
    const initialState = {
      title: "Change Password",
    };
    this.modalService.show(UserChangePwdComponent, {
      initialState,
      ...mdConfig,
      class: "modal-lg",
    });
  }

  async consent() {     
    await beconsent.init({ uid: `${this.currentUser.uid}`, name: `${this.currentUser.firstname} ${this.currentUser.lastname}`})
    beconsent.show();
  }

  async dsrmClick() {
    console.log('dsrmClick');
    
    let data = {
      uid: this.currentUser.uid,
      identity: {
        firstName: this.currentUser.firstname,
        lastName: this.currentUser.lastname,
        email: this.currentUser.email,
        country: "TH",
      },
    };
    dsrm.init(data);
  }

  requestKYCCode(){
    this.router.navigate(["/mainmenu/kyc"]);
  }

  requestKYCHistory(){
    this.router.navigate(["/mainmenu/kyc/history"]);
  }

  
  getMenu(gid: string) {
    this.isLoading = true;
    this.menuService.getMenuList(1, 9999, { gid: gid } as MenuSearch).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.imenus = this.groupMenu((res && res.data) || []);
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  getSubmenu(menuId: string, menus: IMenu[]) {
    return _.sortBy(
      menus.filter((s) => s.parentMenuId == menuId),
      (s) => s.order
    );
  }

  groupMenu(menus: IMenu[]) {
    let menuItems: IMenu[] = menus.filter(
      (m) => !m.isSubMenu && m.parentMenuId == "0"
    );
    for (const menu of menuItems) {
      menu["submenu"] = this.getSubmenu(menu.id, menus);
    }
    return _.sortBy(menuItems, (m) => m.order);
  }
}
